import * as VueRouter from 'vue-router';
import storeRouter from '@/store/router';
import qualificationRouter from '@/qualification/router';

const routes = [...storeRouter, ...qualificationRouter];
routes.unshift({
    path: '/',
    redirect: '/store/shop'
});
routes.push({
    path: '/:pathMatch(.*)*',
    name: '404',
    component: () => import(/* webpackChunkName: "common-404" */ '@/layout/notFond')
});
const router = VueRouter.createRouter({ history: VueRouter.createWebHashHistory(import.meta.env.BASE_URL), routes });

export default router;
